import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../config/axiosConfig";
import config from "../../config/api";

const BackendURL = config.backendUrl;

// ---- ASYNC THUNK ----
export const importAssemblyInventory = createAsyncThunk(
    "assemblyInventory/importAssembly",
    async (formData, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.post(
                `${BackendURL}/assemblyinventory/import`,
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                }
            );

            return response.data; 
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || "Failed to import inventory"
            );
        }
    }
);
const importAssemblyInventorySlice = createSlice({
    name: "importAssemblyInventory",
    initialState: {
        loading: false,
        success: false,
        error: null,
        message: "",
    },
    reducers: {
        resetImportState: (state) => {
            state.loading = false;
            state.success = false;
            state.error = null;
            state.message = "";
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(importAssemblyInventory.pending, (state) => {
                state.loading = true;
                state.success = false;
                state.error = null;
                state.message = "";
            })
            .addCase(importAssemblyInventory.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.message = action.payload.message; // File imported successfully
            })
            .addCase(importAssemblyInventory.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || "Import failed";
            });
    },
});

export const { resetImportState } = importAssemblyInventorySlice.actions;
export default importAssemblyInventorySlice.reducer;
